module.exports = {"app.menu.home":"Inicio","app.menu.statistics":"Estadisticas","app.menu.scan_qr":"Escanear QR","app.menu.login":"Login","app.menu.profile":"Perfil","app.menu.logout":"Cerrar Sesión","app.menu.manage":"Administrar","app.menu.companies":"Departamentos","app.menu.users":"Usuarios","home.machine_list":"Listado de Máquinas"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/es.json
// module id = 1068
// module chunks = 0